// import * as MD from '@material-ui/core';
import * as React from 'react';
import { PlayerContent } from '../Components/Player/PlayerContent';
import { Layout } from '../Components/Layout';
import { setDrawerContent, setPageContent } from '../Store/Layout/Actions';
import { Route, RouteComponentProps } from 'react-router-dom';
import {  IApplicationState, IConnectedReduxProps } from '../Store';
// IApplicationState,
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ILayoutState } from '../Store/Layout/Types';
import { PlayerDrawer } from '../Components/Sidebar/PlayerDrawer';

interface IPropsFromState {
    layout: ILayoutState;
}

interface IPropsFromDispatch {
    setDrawerContent: typeof setDrawerContent;
    setPageContent: typeof setPageContent;
}

type AllProps =
    IPropsFromDispatch &
    IPropsFromState &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

export class PlayerPage extends React.Component<AllProps> {
    public componentDidMount() {
        this.props.setPageContent(<Route component={PlayerContent} />);
        this.props.setDrawerContent(<Route component={PlayerDrawer} />)
    }

    public render(): React.ReactNode {
        return (
            <Route component={Layout} />
        );
    }
}

const mapStateToProps = ({ layout }: IApplicationState) => ({
    layout,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
    setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
});

export const Player = connect(mapStateToProps, mapDispatchToProps)(PlayerPage);
